import { render, staticRenderFns } from "./CSpfAddItemModal.vue?vue&type=template&id=416b95db&scoped=true&"
import script from "./CSpfAddItemModal.vue?vue&type=script&lang=ts&"
export * from "./CSpfAddItemModal.vue?vue&type=script&lang=ts&"
import style0 from "./CSpfAddItemModal.vue?vue&type=style&index=0&id=416b95db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416b95db",
  null
  
)

export default component.exports